import { ProductosApiService } from '../../../../../service/api/productos-api';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TratamientosApiService } from '../../../../../service/api/tratamientos-api.service';
import { FitosanitariosFormDefinition } from './form-control/form-definition';
import { build, pool, buildParams } from '../../../../../common/classes/request-builder';
import { EventPhase, FormPhase } from '../../../../../common/components/reactive-form-builder/form-request';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { WeatherService } from '../../../../../service/api/weather/weather';
import { RecuperarReferenciaRecetaService } from '../../../../../service/recuperar.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { firstValueFrom, Subject } from 'rxjs';
import { TareaFitoModel } from '../../../../../models/tareas/tarea-fito.model';
import { TratamientosControlModel } from '../../../../../models/tratamientos/tratamientos-control.model';
import { MantenimientoModel } from '../../../../../models/trabajadores/mantenimiento.model';
import { ReactiveFormBuilderComponent } from '../../../../../common/components/reactive-form-builder/form-builder.component';
import { FitosanitariosEnvironmentDefinition } from '../environment-variables';
import { ClienteModel } from '../../../../../models/cliente.model';
import { environment } from '../../../../../../environments/environment';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { Utils } from '../../../../../common/utils';
import { ParcelasModel } from '../../../../../models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { FormRequestTypes } from 'src/app/common/classes/form-request';

@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './fitosanitarios-form.component.html',
  styleUrls: ['./fitosanitarios-form.component.scss'],
})
export class FitosanitariosFormComponent extends BaseForm<TareaFitoModel> implements OnInit {
  @ViewChild(ReactiveFormBuilderComponent) formBuilder!: ReactiveFormBuilderComponent<ParcelasModel>;
  
  disabledDates: Date[] = [];

  form!: FitosanitariosFormDefinition;

  formRequest: ReactiveFormBuilderComponent<TareaFitoModel>;

  env: FitosanitariosEnvironmentDefinition = new FitosanitariosEnvironmentDefinition();

  rol = StorageManager.getUser().rol;

  loadingData = true;

  dropdownLoadTrigger = new Subject<void>();

  productsTratamientos: any[] = [];

  constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public formApi: FormCommonApiService,
        public usuariosApi: UsuariosApiService,
        public tareasApi: TareasApiService,
        public fincasApi: FincasApiService,
        public trabajadoresApi: TrabajadoresApiService,
        public tratamientosApi: TratamientosApiService,
        public clientesApi: ClientesApiService,
        public productosApi: ProductosApiService,
        public siexApi: SiexApiService,
        public override router: Router,
        public dashboardEvent: DashboardService,
        private weatherService: WeatherService,
        private recuperarService: RecuperarReferenciaRecetaService,
        private http: HttpClient,
        private messageService: MessageService,
  ) {
    super(
      route,
      router,
      dashboard,
      tareasApi.fitosanitariosPUT,
      tareasApi.fitosanitariosPOST,
      'fitosanitarios',
      'Actualizar Tarea Fitosanitaria',
      'Realizar Tarea Fitosanitaria',
      'Duplicar Tarea Fitosanitaria',
    );
    this.formRequest = new ReactiveFormBuilderComponent(this.http);
  }

  ngOnInit() {
    this.dashboard.clientChanges$.subscribe(() => {
      this.fincasApi.fincasGET.unsuscribe();
      this.fincasApi.sectoresGET.unsuscribe();
      this.fincasApi.parcelasGET.unsuscribe();
      this.tratamientosApi.tratamientosList.unsuscribe();
      if (this.env.filterAplicadoresByClient) {
        this.trabajadoresApi.trabajadoresGET.unsuscribe();
        this.trabajadoresApi.maquinariaGET.unsuscribe();
      }
    });

    this.expandFormRequest();
    this.softInit(this.getType());
    this.setupFormConFechas();
  }

  createTaskAgro() {
    if (environment.appName === 'avafitogest') {

      const isArroz = this.form.model.ids_parcelas.map((parcela: ParcelasModel) =>
        parcela.cultivo?.toLocaleLowerCase()).includes('arroz');

      if (isArroz) {
        const idsParcelas = this.form.model.ids_parcelas.map((parcela: ParcelasModel) => parcela.id).join(';');
        const idsSectores = this.form.model.id_sector.map((sector: SectorModel) => sector.id).join(';');


        const taskEcorregiment = {
          id_cliente: this.form.model.id_cliente,
          id_usuario: StorageManager.getUser().id,
          id_finca: this.form.model.id_finca.id,
          id_sector: idsSectores,
          id_parcelas: idsParcelas,
          fecha_seca_inicio_intermitente: moment(Utils.toDate(this.form.model.fecha_fin as string)).add(-1, 'days').format('DD/MM/YYYY'),
          fecha_seca_fin_intermitente: moment(Utils.toDate(this.form.model.fecha_fin as string)).add(+1, 'days').format('DD/MM/YYYY'),
        };

        const params = new HttpParams().append('p1', 'generic').append('p2', 'tareas_agroambientales');

        this.http.post(`${environment.serverUrl}ws/index.php`, taskEcorregiment, { params: params }).subscribe((res: any) => {
          if (res['statusCode'] === 201 && res['statusCode'] === 'Created') {
            this.messageService.add({
              severity: 'success',
              summary: 'Registro añadido',
              detail: 'Se ha creado una tarea agroambiental con fecha.' +  
                taskEcorregiment.fecha_seca_inicio_intermitente + ' y ' +  taskEcorregiment.fecha_seca_fin_intermitente,
            });
          }
        });
      }


    }
  }

  formChanges(formModel: [object, string], tag: string) {

    this.form.model = formModel as unknown as TareaFitoModel;
    this.form.tag = tag;

    if (tag === 'ids_parcelas' && this.getType() === FormRequestTypes.CREATE) {
      this.form.model.sup_cultivada = Utils.decimalFormat(((this.form.lists.parcelas.selected as ReadonlyArray<ParcelasModel>) ?? [])
    .reduce((acc, parcela) => acc + this.toFiniteNumber(parcela?.superficie_cultivada), 0), 2, '.', ',', 3);
      this.formBuilder.updateForm(this.form.model, false);
    }

    if (this.env.appName === 'pyf') {
      this.form.recuperarService = this.recuperarService;
    }
    if (this.env.showClimatologia) {
      this.form.weatherService = this.weatherService;
    }
    
    if (tag === 'id_cliente' && this.env.appName !== 'agricar') {
      if (this.form.lists.clientes.selected) {
        StorageManager.saveClient(this.form.lists.clientes.selected);
      }
      this.dashboardEvent.emitClientChange();

      const builds = [
        buildParams(this.fincasApi.fincasGET,
          { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
          this.form.lists.fincas,
          'nombre', true),
        buildParams(this.fincasApi.sectoresGET,
          { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
          this.form.lists.sectores,
          'nombre', true),
        buildParams(this.fincasApi.parcelasGET,
          { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
          this.form.lists.parcelas,
          ['nombre', 'municipio'], true),
        buildParams(this.tratamientosApi.tratamientosList,
          { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
          this.form.lists.tratamientos,
          'nombre', true),
      ];

      if (this.env.appName === 'prosanzcu') {
        builds.push(
          buildParams(this.fincasApi.parcelasGET,
            { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
            this.form.lists.parcelas,
            ['nombre', 'municipio', 'poligono'], true),
        );
      } else {
        builds.push(
          buildParams(this.fincasApi.parcelasGET,
            { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
            this.form.lists.parcelas,
            'nombre', true),
        );
      }

      if (this.env.filterAplicadoresByClient) {
        builds.push(
          buildParams(
            this.trabajadoresApi.trabajadoresGET,
            { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
            this.form.lists.trabajadores, 'nombre', true),
          buildParams(this.trabajadoresApi.maquinariaGET,
            { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel).id },
            this.form.lists.maquinarias, 'nombre', true),
        );
      }

      pool(builds, () => {
        this.form.lists.fincas.filtered = this.form.lists.fincas.values;
        this.form.lists.parcelas.values = this.form.lists.parcelas.values.filter(it => (it.label !== '...'));
        this.form.lists.tratamientos.filtered = this.form.lists.tratamientos.values;

        if (this.env.filterAplicadoresByClient) {
          this.form.lists.trabajadores.filtered = this.form.lists.trabajadores.values.filter(it => (it.label !== '...'));
          this.form.lists.maquinarias.filtered = this.form.lists.maquinarias.values;
        }
      }).then(() => {
        if (this.env.appName === 'avafitogest') {
          this.form.lists.parcelas.values = this.form.lists.parcelas.values
            .filter(it => it.label !== '...')
            .map(it => ({
              ...it,
              label: this.parcelaLabel(it.value as ParcelasModel)
            }));
          this.form.lists.parcelas.filtered = this.form.lists.parcelas.values;
        }

        this.formRequest.executePhase(FormPhase.UPDATE);

        return;
      }).catch(e => {
        console.log(`catch en pool: ${  e}`);
      },
      );
    }
  }

  /** Carga las fechas y luego crea el form-definition con ellas */
  private async setupFormConFechas(): Promise<void> {
    if (environment.appName === 'detorres') {
      const { dates, eventos } = await this.getEventosAPI();

      this.disabledDates = dates;

      // 2) Con las fechas, instancio el form-definition
      this.form = new FitosanitariosFormDefinition(
        this.getType(),
        localStorage.getItem('tratamiento_temp')
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ? JSON.parse(localStorage.getItem('tratamiento_temp')!)
          : this.getModel(),
        null,
        this.disabledDates,
        eventos,       // <-- aquí pasamos las fechas cargadas
      );
    } else {
      this.form = new FitosanitariosFormDefinition(
        this.getType(),
        localStorage.getItem('tratamiento_temp')
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ? JSON.parse(localStorage.getItem('tratamiento_temp')!)
          : this.getModel(),
        null,
        [],
        [],
      );
    }

    // 3) Asigno el model al form-definition
    this.form.model = this.model;

    // 4) Continúo con la inicialización del form-builder
    this.initFormData();
    this.formRequest.executePhase(FormPhase.LOAD);
  }

  private expandFormRequest(): void {
    this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
      localStorage.removeItem('tratamiento_temp');
      resolve(true);
    });

    this.formRequest.addEvent(FormPhase.SEND, EventPhase.AFTER, (resolve) => {
      StorageManager.saveSessionDataDonJardin(
        this.form.model.id_finca ?? '',
        this.form.model.hora_inicio ?? '',
        this.form.model.hora_fin?.toString() ?? '',
      );
      resolve(true);
    });

    let isControl = false;
    let controlObtenido: TratamientosControlModel[] = [];

    this.formRequest.addEvent(FormPhase.SEND, EventPhase.AFTER, (resolve) => {
      if (this.env.appName === 'hernandorena') {
        this.tratamientosApi.tratamientosControl.GET.toPromise({
          id_tarea: this.form.model.id,
        } as never).then(control => {
          if (control?.[0]) {
            controlObtenido = control;
            isControl = true;
          } else {
            resolve(true);
          }

          return;
        }).catch(e => {
          console.log(`catch en formRequest: ${  e}`);
        },
        );
      } else {
        resolve(true);
      }
    });

    if (isControl) {
      this.tratamientosApi.tratamientosControl.PUT.toPromise({
        id: controlObtenido[0]?.id,
        estado: this.form.model.aplicado ? 'Aplicado' : 'Planificado',
      } as never).then(() => {
        console.log('Control Obtenido');

        return;
      }).catch(e => {
        console.log(`catch en getPosition: ${  e}`);
      },
      );
    }
  }

  private initFormData(): Promise<boolean> {
    this.loadingData = true;

    const buildsRequest = this.getBuildsRequest();

    return pool(buildsRequest, () => {
      this.formRequest.executePhase(FormPhase.UPDATE);
      this.loadingData = false;
    }).then(() => {
      this.dropdownLoadTrigger.next();

      return true;
    });
  }

  private getBuildsRequest(): any {
    const buildsRequest = [
      build(this.clientesApi.clientesGET, this.form.lists.clientes, { or: ['razon_social', 'nombre'] }),
      build(this.tratamientosApi.tratamientosList, this.form.lists.tratamientos, 'nombre', true),
      build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true),
      build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
      build(this.fincasApi.parcelasGET, this.form.lists.parcelas, 
      this.env.appName === 'avafitogest' ? this.parcelaLabel : 'nombre', true),
      build(this.siexApi.justificacionesActuacionGET, this.form.lists.justificaciones, 'justificacion'),
      build(this.trabajadoresApi.maquinariaGET, this.form.lists.maquinarias,
        (it: MaquinariaModel) => `${it.nombre  } ${it.empresa
          ? ` - (${  it.empresa || '...'  })`
          : ''}`, true),
      build(this.trabajadoresApi.trabajadoresGET, this.form.lists.trabajadores,
        (it: MantenimientoModel) => `${it.nombre  } ${  it.apellidos || ''  }${it.maquinaria
          ? ` - (${  it.maquinaria || '...'  })`
          : ''}`,
        true, true),

    ];

    if (this.env.showAssignUserTasksFitosanitario || this.env.showAssignUserInAllTasks) {
      buildsRequest.push(build(this.usuariosApi.usuariosGET, this.form.lists.usuarios, 'nombre'));
    }

    if (this.env.appName === 'innovia') {
      buildsRequest.push(build(this.productosApi.productos.GET, this.form.lists.productos, 'nombre'));
    }

    return buildsRequest;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public async getEventosAPI(): Promise<{
        dates: Date[];
        eventos: { start: string; title: string; hora_inicio: string; hora_fin: string }[];
    }> {
    const fechas: Date[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let eventosRaw: any[] = [];

    try {
      eventosRaw = await this.tareasApi.eventos.GET.toPromise();
      for (const ev of eventosRaw) {
        const [dd, mm, yyyy] = ev.start.split('-').map(Number);

        if ([dd, mm, yyyy].every(Number.isInteger)) {
          fechas.push(new Date(yyyy, mm - 1, dd));
        }
      }
    } catch (err) {
      console.error('Error cargando eventos:', err);
    }

    return { dates: fechas, eventos: eventosRaw };
  }

  async getDataProducts(): Promise<void> {
    if (this.form.lists.tratamientos.selected) {
      const tratamiento = this.form.lists.tratamientos.selected as any;

      if (tratamiento?.ids_usos) {
        const idsUsos = tratamiento.ids_usos.split(';');

        if (idsUsos.length > 0) {
          const result = await firstValueFrom(this.http.get<any>(
            `${environment.serverUrl}ws/index.php?p1=mg&p2=getById&id=${idsUsos}`,
          ));

          this.productsTratamientos = result?.data || [];
          
        }
      } else {
        this.form.lists.productos.values = [];
        this.form.lists.productos.filtered = [];
      }
    }
  }

  private parcelaLabel = (p: ParcelasModel) => {
    const nombre = (p.nombre ?? '').toString().trim();

    const pol = (p.poligono ?? '').toString().trim();
    const num = (p.numero ?? '').toString().trim();     // "parcela" SIGPAC
    const rec = (p.recinto ?? '').toString().trim();
    const codigos = [pol, num, rec].filter(Boolean).join('-'); // ej: 12-345-A

    const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
    const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
    const supFmt = supNum.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const uds = this.env.textoSuperficie || 'ha';

    // Construye la parte derecha: "12-345-A · 1,23 ha" (si falta algún trozo, no lo muestra)
    const derecha = [codigos || undefined, `${supFmt} ${uds}`].filter(Boolean).join(' · ');

    // Nombre primero; si no hay códigos, al menos mostrará "Nombre · 1,23 ha"
    return [nombre, derecha].filter(Boolean).join(' — ');
  };

      /** Coerce a value to a finite number; returns 0 if not numeric. */
    public toFiniteNumber(v: unknown): number {
        if (typeof v === 'number') {return Number.isFinite(v) ? v : 0;}
        if (typeof v === 'string') {
            const s = v.trim();
            
            if (s === '' || /^(?:NaN|undefined|null)$/i.test(s)) {return 0;}
            // remove thousand separators and normalize decimal comma
            const cleaned = s.replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(/,/, '.');
            const n = Number(cleaned);
            
            return Number.isFinite(n) ? n : 0;
        }
    return 0;
  }
}